export default __webpack_public_path__ + "static/thumb-romax-4000-bd28f0d266f28dcb5478e0fd3570f9a9.jpg";